import { render, staticRenderFns } from "./cardC.vue?vue&type=template&id=5d5259fc&"
import script from "./cardC.vue?vue&type=script&lang=js&"
export * from "./cardC.vue?vue&type=script&lang=js&"
import style0 from "./cardC.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports